
<template>
  <div class="banner" id="banner">
    <swiper class="swiper" :options="swiperOption">
      <swiper-slide>
        <img src="/images/sliderImages/homeslider.jpg" alt />
      </swiper-slide>
      <swiper-slide>
        <div class="img-overlay"></div>
        <img src="/images/sliderImages/slide4.jpg" class="img-with-text" />
        <h2 class="img-text">
          We Deliver Perfect
          <span class="bolder">Media Solutions</span>
        </h2>
      </swiper-slide>
      <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div>
    </swiper>
  </div>
</template>

<script>
export default {
  name: "swiper-example-navigation",
  title: "Navigation",
  components: {},
  data() {
    return {
      swiperOption: {
        loop: true,
        autoplay: { delay: 3000 },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      }
    };
  }
};
</script>

<style scoped>
.banner {
}
.banner img {
  width: 100%;
}
.img-with-text {
  position: relative;
}
.img-overlay {
  background: rgba(255, 255, 255, 0.1);
  height: 100%;
  width: 100%;
  content: "";
  position: absolute;
  z-index: 99;
}
.img-text {
  top: 50%;
  position: absolute;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  text-align: center;
  color: #000;
  font-weight: 700;
  font-size: 24px;
  text-transform: uppercase;
}
.bolder {
  font-weight: 900;
}
</style>